export var unblockScreenShare = function () {
    var fakeEvent = new Event('unhandledrejection');
    fakeEvent.reason = { name: 'NotAllowedError' };
    window.dispatchEvent(fakeEvent);
};
export var unblockAutoPlay = function () {
    var options = {};
    if (navigator.mediaDevices.getSupportedConstraints().sampleRate) {
        options.sampleRate = 48000;
    }
    var anyWindow = window;
    anyWindow.wixLiveVideoAudioContext = new (anyWindow.AudioContext || anyWindow.webkitAudioContext)(options);
    anyWindow.wixLiveVideoAudioContext.resume();
    document.createElement('audio').play();
};
export var unblockSoundIOS = function () {
    return document.querySelector('#wix-amazon-audio').play();
};
//# sourceMappingURL=amazon-hacks.js.map